import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { DateCellComponent } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const createdAtColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.CreatedAt,
  label: injectTranslate()('app.offers.table.create_date'),
  visible: false,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 150,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: ({ row }) =>
    componentOutletConfigFactory(DateCellComponent, {
      inputs: {
        time: row.createdAt,
        tooltipPosition: 'left',
      },
    }),
}));
